// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BellTwoToneSvg from "@ant-design/icons-svg/es/asn/BellTwoTone";
import AntdIcon from '../components/AntdIcon';

var BellTwoTone = function BellTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: BellTwoToneSvg
  }));
};

BellTwoTone.displayName = 'BellTwoTone';
export default /*#__PURE__*/React.forwardRef(BellTwoTone);